<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <!-- Layout (reuse SectionLayout) -->
        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <!-- List Style -->
        <div class="mb-5">
          <label class="label-input">List Style</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Icon Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.bgIcon"
                    @input="event => (fields.bgIcon = event.target.value)"
                  />
                  <v-text-field v-model="fields.bgIcon" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Columns Per View</label>
                <v-select v-model.number="fields.colPerView" :items="[2, 3, 4, 5, 6]" hide-details class="mt-0" />
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Title Card -->
        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields.titleCard.show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields.titleCard.show"
              :editor="editor"
              v-model="fields.titleCard.content"
              :config="editorConfig"
            />
          </div>
        </div>

        <!-- List Items -->
        <div class="mb-7">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">List Item</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.items" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-5">
                  <label>Icon</label>
                  <UploadImage
                    :image="{ imageSrc: item.icon }"
                    :height="`150`"
                    :typeUpload="'image'"
                    @callback="obj => handleUploadIcon(obj, i)"
                    @callbackDelete="handleRemoveUpload(i)"
                  />
                </div>
                <div class="mb-3">
                  <label>Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

const getDefaultFields = () => ({
  title: 'Text With Icon Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  bgIcon: '#003568',
  colPerView: 4,
  titleCard: {
    show: true,
    content: '<h2>text with icon</h2><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>',
  },
  items: [],
});

export default {
  name: 'text-with-icon-section-editor',
  components: {
    UploadImage,
    SectionLayout,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});
    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      titleCard: { ...def.titleCard, ...(extract.titleCard || {}) },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTextWithIcon(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadIcon(obj, i) {
      this.fields.items[i].icon = obj.imageSrc;
    },
    handleRemoveUpload(i) {
      this.fields.items[i].icon = '';
    },
    handleAddItem() {
      this.fields.items.push({
        icon: '',
        content: '<h3>Heading</h3><p>Description</p>',
      });
    },
    handleRemoveItem(i) {
      this.fields.items.splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline {
  min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
